import styled from 'styled-components'

export const Checkbox = styled.label`
  display: flex;
  align-items: center;
  margin: 4px 0;
  .Checkbox__Label {
    margin-left: 8px;
    color: ${p => p.theme.webMktPalette.text.primary};
  }
  .Checkbox__Input {
    width: 14.75px;
    height: 14.75px;
  }
`

export const MoreResourcesContainer = styled.div`
  .ResourceListing__Filters-Want-More-Text--dark {
    color: ${p => p.theme.webMktPalette.text.primaryWhite};
    margin-top: 24px;
  }
  .CTA {
    margin-top: 8px;
  }
`

export const SearchResultsDescription = styled.div`
  ${(p: any) =>
    p.isEvents
      ? `
        h5 {
          color: ${p.theme.webMktPalette.text.primaryWhite};
        }
      `
      : ``}

  display: none;
  margin-bottom: 64px;
  &.active {
    display: block;
  }

  p {
    margin-top: 24px;
    color: ${p => p.theme.webMktPalette.text.secondary};
  }

  span {
    color: ${p => p.theme.webMktPalette.text.secondary};
  }
`

export const SearchIconContainer = styled.div`
  background: ${(p: any) =>
    p.isEvents
      ? p.theme.webMktPalette.button.secondaryWhite
      : p.theme.webMktPalette.button.secondaryBlack};
  width: 48px;
  height: 48px;
  margin-right: 4px;
  position: relative;
  cursor: pointer;
  .search-icon {
    path {
      fill: ${(p: any) =>
        p.isEvents ? p.theme.webMktPalette.icon.black : p.theme.webMktPalette.icon.white};
      transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);
    }
  }

  &:hover {
    .search-icon {
      path {
        fill: ${(p: any) =>
          p.isEvents ? p.theme.webMktPalette.icon.black30 : p.theme.webMktPalette.icon.white30};
      }
    }
  }
`

export const InputContainer = styled.div`
  position: relative;
  transition: all 0.2s ease-in-out;
  max-width: 0;
  opacity: 0;

  &.active {
    max-width: 100%;
    opacity: 1;
  }

  input {
    padding: 12px 40px 12px 16px;
    width: 192px;
    max-width: 100%;
    height: 48px;
    box-sizing: border-box;
    border-radius: 0px;
    border: 1px solid rgba(0, 0, 0, 0.301961);
  }
`

export const SearchContainer = styled.div`
  display: flex;
  height: 48px;
  float: left;

  .close-icon {
    transition: all 0.2s ease-in-out;
    position: absolute;
    width: 16px;
    opacity: 0;
    cursor: pointer;
    height: 16px;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);

    &.active {
      opacity: 1;
    }

    &:hover path {
      fill: ${p => p.theme.webMktPalette.error[50]};
    }
  }

  .search-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${p => p.theme.breakpoints.down('sm')} {
    ${SearchIconContainer} {
      margin-right: 16px;
    }

    .close-icon {
      transition: none;
    }

    ${InputContainer} {
      transition: none;
      max-width: 100%;
      width: 263px;
      opacity: 1;
      input {
        width: 100%;
      }
    }
  }

  ${p => p.theme.breakpoints.down('xs')} {
    float: none;
    margin-bottom: 16px;

    ${InputContainer} {
      width: calc(100% - 48px);
    }

    ${SearchIconContainer} {
      margin-right: 0px;
    }
  }
`

export const ToggleText = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  .Toggle-Text__Label {
    margin-left: 8px;
    color: ${(p: any) =>
      p.useCase === 'Events'
        ? p.theme.webMktPalette.text.actionDark
        : p.theme.webMktPalette.text.actionLight};
  }
  .Toggle-Text__Label-Black {
    margin-left: 8px;
    color: ${(p: any) =>
      p.useCase === 'Events'
        ? p.theme.webMktPalette.text.primaryWhite
        : p.theme.webMktPalette.text.primary};
  }
  &:hover {
    .Toggle-Text__Label,
    .Toggle-Text__Label-Black {
      text-decoration: underline;
    }
  }
  &.Toggle-Text--Margin-Bottom {
    margin-bottom: 36px;
  }
`

export const FilterGroup = styled.div`
  margin-bottom: 36px;
  .Toggle-Text__Button {
    flex-direction: row;
    align-items: center;
  }
  .Toggle-Text__Button--More {
    display: flex;
  }
  .Toggle-Text__Button--Less {
    display: none;
  }
  .Filter-Group__Secondary-Items {
    display: none;
  }
  .Filter-Group__Arrow {
    transform: none;
    transition: all 0.2s ease;
  }
  &.Secondary-Drawer__Active {
    .Filter-Group__Secondary-Items {
      display: block;
    }
    .Filter-Group__Arrow {
      transform: rotate(180deg);
    }
    .Toggle-Text__Button--More {
      display: none;
    }
    .Toggle-Text__Button--Less {
      display: flex;
    }
  }
`

export const ResourcePageOuter = styled.div`
  background: ${(p: any) =>
    p.useCase === 'Events'
      ? p.theme.webMktPalette.background.dark
      : p.theme.webMktPalette.background.gray};
`
export const ResourceListingTopFilterContainer = styled.div`
  margin-bottom: 48px;
  padding-top: 48px;
  ${p => p.theme.breakpoints.down('xs')} {
    padding-top: ${(p: any) => (p.isEvents ? '48px' : '0')};
  }

  .ResourceCenter__Tab__BTNS {
    height: 48px;
    border: 1px solid #0000004d;
    margin: 0 4px 8px 4px;
    padding: 12px 16px;
    ${p => p.theme.breakpoints.down('sm')} {
      margin: 0;
      height: 48px;
    }
  }

  a.ResourceCenter__Tab__BTNS__active {
    background-color: ${p => p.theme.webMktPalette.blue[50]};
    color: ${p => p.theme.webMktPalette.text.primaryWhite};
  }

  a.ResourceCenter__Tab__BTNS:hover {
    background-color: ${p => p.theme.webMktPalette.blue[50]};
  }

  .Search__Button {
    display: block;
    margin: 0 4px 8px 0px;
    padding: 0px !important;
    width: 48px;
    height: 48px;
  }

  .Tab__desktop_buttons {
    margin: 0 -4px;
    ${p => p.theme.breakpoints.down('sm')} {
      display: none;
    }
  }
`

export const ResourceListingContainer = styled.div`
  ${(p: any) => {
    if (p.useCase === 'Events') {
      return `
        background-color: ${p.theme.webMktPalette.background.dark};
        .ResourceItem-Title {
          color: ${p.theme.webMktPalette.text.primaryWhite};
        }
        .ResourceItem-Text-Category-Date {
          p.ResourceItem-Text-Category {
            color: ${p.theme.webMktPalette.grayNeutral[45]};
          }
          p.ResourceItem-Text-Date {
            color: ${p.theme.webMktPalette.text.secondary};
          }
        }
        p.ResourceItem-Subtitle {
          color: ${p.theme.webMktPalette.grayNeutral[45]};
        }

        div.ResourceRow__Outer-Container {
          padding: 0;
        }

        div.ResourceRowContainer {
          padding-top: 0;
          padding-bottom: 48px;
          background: none;
        }

        .Pagination__Numbered-Button, .Pagination__Next-Button {
          background-color: ${p.theme.webMktPalette.background.dark};
          border: 2px solid ${p.theme.webMktPalette.text.tertiaryDark};
          color: ${p.theme.webMktPalette.text.primaryWhite};
        }

        .Pagination__Button-Text > * {
          color: ${p.theme.webMktPalette.text.primaryWhite};
        }

        div.Pagination__Inner-Container > a.Pagination__Numbered-Button--Active {
          border: 2px solid ${p.theme.webMktPalette.text.primaryWhite};
        }

        .ResourceRow__SeeAllItemsIntro, .ResourceRow__CTA-Container {
          display: none;
        }

        .Filter-Name, .Checkbox__Label {
          color: ${p.theme.webMktPalette.text.primaryWhite};
        }

      `
    }
  }}
  div[class*='ContentBlock--'] {
    background: none;
  }

  div[class*='ContentBlock--'] > div {
    padding: 0;
  }
`

export const ResourceListingBottomContainer = styled.div`
  display: flex;
  padding-bottom: 24px;
  ${p => p.theme.breakpoints.down('sm')} {
    flex-direction: column;
  }
`

export const ResourceListingLeftFilterContainer = styled.div`
  width: 282px;
  min-width: 282px;
  margin-right: 24px;

  ${(p: any) => {
    if (!p.displayFilters && p.defaultLocale === 'en-US') {
      return `display: none;`
    } else if (!p.displayFilters) {
      //is localized page
      return `
          .ResourceListing__Filters-Mobile-Actions,
          .ResourceListing__Filters-Inner-Container {
            display: none;
          }
        `
    }
  }}
  ${p => p.theme.breakpoints.down('sm')} {
    transition: right 0.2s ease;
    right: ${(p: any) => (p.mobileDrawerOpen ? '0' : '-1000px')};
    background: ${(p: any) =>
      p.useCase === 'Events'
        ? p.theme.webMktPalette.background.dark
        : p.theme.webMktPalette.background.gray};
    position: absolute;
    z-index: 100;
    width: 100%;
    height: 100%;
    margin: 0;
    top: 0;
  }
  .ResourceListing__Filters-Mobile-Actions {
    display: none;
    ${p => p.theme.breakpoints.down('sm')} {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 8px 16px;
      max-width: 548px;
      margin: 0 auto;
      justify-content: space-between;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      max-width: 304px;
    }
  }
  .ResourceListing__Filters-Inner-Container {
    .Filters--hide {
      display: none;
    }
    ${p => p.theme.breakpoints.down('sm')} {
      max-width: 548px;
      margin: 32px auto 0 auto;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      max-width: 304px;
    }
  }
  .Filter-By__Label {
    color: ${p => p.theme.webMktPalette.text.secondary};
    margin-top: 0;
    margin-bottom: 8px;
  }
  .Filter-Name {
    color: ${p => p.theme.webMktPalette.text.primary};
    margin-bottom: 8px;
  }
  div.ContentBlock__Inner-Container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .ContentBlock__Headline,
  .ContentBlock__Fineprint {
    display: none;
  }

  p.ContentBlock__Body {
    p {
      line-height: 24px;
      font-size: 16px;
    }
  }
`

export const TrendingResourcesContainer = styled.div`
  > p {
    margin-bottom: 24px;
  }
`

export const ResourceListingItemContainer = styled.div`
  ${(p: any) => {
    if (p.columns === 4) {
      return `grid-template-columns: repeat(4, minmax(0, 1fr));`
    } else return `grid-template-columns: repeat(3, minmax(0, 1fr));`
  }}
  display: grid;

  grid-column-gap: 24px;
  align-items: flex-start;
  grid-row-gap: 64px;
  padding-bottom: 64px;
  ${p => p.theme.breakpoints.down('sm')} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-column-gap: 14px;
  }
  ${p => p.theme.breakpoints.down('xs')} {
    grid-template-columns: minmax(100%, 1fr);
    grid-column-gap: 0;
  }
`

export const ResourceItem = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  &:hover {
    .ResourceItem-Title {
      color: ${(p: any) =>
        p.isEvents
          ? p.theme.webMktPalette.text.actionDark
          : p.theme.webMktPalette.text.actionLight};
    }
    .ResourceItem-Img-Container {
      .ResourceItem-Img-Overlay {
        opacity: 0.2;
      }
    }
    .VideoPlayIcon__Circle {
      fill-opacity: 1;
    }
  }
  .VideoPlayIcon__Circle {
    transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);
  }

  .ResourceItem-Pills-Container {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
  }

  .ResourceItem-Pill {
    background: ${p => p.theme.webMktPalette.background.white};
    z-index: 2;
    margin-right: 1px;
    padding: 4px 8px;
    p {
      color: ${p => p.theme.webMktPalette.text.secondary};
      margin: 0;
    }
  }
  .ResourceItem-Img-Container {
    width: 100%;
    margin-bottom: 32px;
    overflow: hidden;
    position: relative;
    padding-bottom: 56.2%;
    background-color: gray;

    .ResourceItem-Img {
      position: absolute;
      object-fit: cover;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .ResourceItem-Img-Overlay {
      transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);
      height: 100%;
      width: 100%;
      background: ${p => p.theme.webMktPalette.background.dark};
      position: absolute;
      z-index: 1;
      opacity: 0.1;
    }

    .ResourceItem__Item-Icon {
      position: absolute;
      left: 1px;
      bottom: 1px;
      height: 48px;
      width: 48px;
      z-index: 2;
      ${(p: any) => {
        if (p.isVideoDemo) {
          return `
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        `
        }
      }}
    }
    .ResourceItem__Item-Case-Study-Logo {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 50%);
      bottom: 50%;
      height: auto;
      max-width: 175px;
      z-index: 2;
    }
  }
  .ResourceItem-Text-Category-Date {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ResourceItemCategoryTextContainer {
      display: flex;
      justify-content: center;
      align-items: center;
      .ResourceItem-Text-Featured {
        color: ${p => p.theme.webMktPalette.text.primaryWhite};
        padding: 0 8px;
        background-color: #fa4616;
        margin-right: 8px;
      }
    }
    .ResourceItem-Text-Category {
      margin: 0 16px 0 0;
      color: ${p => p.theme.webMktPalette.text.secondary};
    }
    .ResourceItem-Text-Date {
      color: rgba(0, 0, 0, 0.3);
    }
  }
  .ResourceItem-Text-Category-Date,
  .ResourceItem-Title {
    margin-bottom: 16px;
    color: ${p => p.theme.webMktPalette.text.primary};
  }
  .ResourceItem-Subtitle {
    color: ${p => p.theme.webMktPalette.text.secondary};
  }
  .ResourceItem-Title {
    transition: 0.1s all cubic-bezier(0.4, 0, 0.2, 1);
    ${p => p.theme.breakpoints.down('xs')} {
      letter-spacing: -1px;
    }
  }
`
